import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigModule, I18nConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { ToggleStatusModule, UnitFormService, MessageModule } from '@spartacus/organization/administration/components';
import { CardModule, IconModule, KeyboardFocusModule, PaginationModule, SplitViewModule, TableModule } from '@spartacus/storefront';
import { uigUnitsCmsConfig, uigUnitsRoutingConfig } from './uig-units.config';
import { UigUnitListModule } from './uig-unit-list/uig-unit-list.module';
import { UigUnitFormModule } from './uig-unit-form/uig-unit-form.module';
import { UigUnitFormService } from '../services/uig-unit-form.service';
import { FormsModule } from '@angular/forms';
import { UigUnitDetailsComponent } from './uig-unit-details/uig-unit-details.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SplitViewModule,
        TableModule,
        IconModule,
        UrlModule,
        I18nModule,
        PaginationModule,
        FormsModule,
        MessageModule,
        KeyboardFocusModule,
        CardModule,
        ToggleStatusModule,
        UigUnitFormModule,
        UigUnitListModule,
        ConfigModule.withConfig(uigUnitsRoutingConfig),
        ConfigModule.withConfig(uigUnitsCmsConfig),
    ],
    providers: [
        {
            provide: UnitFormService,
            useClass: UigUnitFormService
        },
        provideConfig(<I18nConfig>{
            i18n: {
                chunks: { uigUnits: ['units', 'unitsBreadcrumbs'] },
            },
        }),
    ],
    declarations: [UigUnitDetailsComponent],
    exports: [UigUnitDetailsComponent],
})
export class UigUnitsComponentsModule { }